// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "554d7fbccb1d4435d93b" + "/js/" + chunkId + ".js";
};